import { Box, Container, Grid, Sheet, Typography } from '@mui/joy';
import {
    EnvelopeSimple,
    ChatCircleDots,
    SignIn
} from '@phosphor-icons/react';
import { FadeIn } from './FadeIn';
import { IconBadge } from './IconBadge';

const STEPS = [
    { icon: EnvelopeSimple, title: 'Вводите почту', text: 'Никаких длинных анкет, максимально просто.' },
    { icon: ChatCircleDots, title: 'Получаете код', text: 'Мы отправим одноразовый код на почту.' },
    { icon: SignIn, title: 'Готово!', text: 'Можно писать, звонить и делиться записями.' },
];

export function HowItWorksSection() {
    return (
        <Container maxWidth="lg">
            <Box sx={{ my: { md: 12, xs: 6 } }}>
                <FadeIn>
                    <Typography
                        level="h2"
                        sx={{ fontWeight: 700, textAlign: 'center', fontSize: { xs: '1.7rem', md: '2.5rem' }, mb: 1 }}
                    >
                        Можно начать за минуту
                    </Typography>
                    <Typography level="body-lg" sx={{ color: 'text.secondary', textAlign: 'center', mb: { xs: 4, md: 6 } }}>
                        Без паролей и сложной регистрации.
                    </Typography>
                </FadeIn>
                <Grid container spacing={3}>
                    {STEPS.map((s, i) => (
                        <Grid key={s.title} xs={12} md={4}>
                            <FadeIn delay={i * 0.1} sx={{ height: '100%' }}>
                                <Sheet
                                    variant="soft"
                                    sx={{
                                        p: 3.5,
                                        height: '100%',
                                        borderRadius: '24px',
                                        backgroundColor: 'rgba(89, 160, 244, 0.07)',
                                        position: 'relative',
                                    }}
                                >
                                    <Typography
                                        level="h2"
                                        sx={{
                                            position: 'absolute',
                                            top: 20,
                                            right: 24,
                                            fontWeight: 800,
                                            color: 'rgba(89, 160, 244, 0.6)',
                                        }}
                                    >
                                        {i + 1}
                                    </Typography>
                                    <IconBadge icon={s.icon} />
                                    <Typography level="title-lg" sx={{ fontWeight: 700, mb: 1 }}>
                                        {s.title}
                                    </Typography>
                                    <Typography level="body-md" sx={{ color: 'text.secondary' }}>
                                        {s.text}
                                    </Typography>
                                </Sheet>
                            </FadeIn>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Container>
    );
}
